import get from 'lodash/get';
import React, {Component} from 'react';
import {FastField, ErrorMessage} from 'formik';
import {FormattedMessage} from 'react-intl';
import classNames from 'classnames';
import messages from '../../../../res/translations/messages';
import {generateNextChoiceId} from '../../../services/idHelpers';
import MinusButton from './MinusButton';
import PlusButton from './PlusButton';
import UpButton from './UpButton';
import DownButton from './DownButton';
import Error from '../../Error';
import TooltipIcon from '../../TooltipIcon';
import DraggableCell from './DraggableCell';
import DraggableRow from './DraggableRow';
import DragDropTableBody from './DragDropTableBody';


class ShuffledDetailChoiceType extends Component {
    constructor(props) {
        super(props);
        this.state = {shuffled: false, detail: false};

        this.addChoice = this.addChoice.bind(this);
        this.toggleShuffle = this.toggleShuffle.bind(this);
        this.toggleDetail = this.toggleDetail.bind(this);
    }

    componentDidMount() {
        const {form, name} = this.props;
        const fields = get(form.values, name);
        const countS = fields.filter((field) => field.shuffle).length;
        if (countS > 0 && countS === fields.length) {
            this.setState({shuffled: true});
        } else if (countS === 0) {
            this.setState({shuffled: false});
        }
        const countD = fields.filter((field) => field.detail).length;
        if (countD > 0 && countD === fields.length) {
            this.setState({detail: true});
        } else if (countD === 0) {
            this.setState({detail: false});
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const {form, name} = this.props;
        const fields = get(form.values, name);
        const countS = fields.filter((field) => field.shuffle).length;
        if (countS > 0 && countS === fields.length && prevState.shuffled !== true) {
            this.setState({shuffled: true});
        } else if (countS === 0 && prevState.shuffled !== false) {
            this.setState({shuffled: false});
        }
        const countD = fields.filter((field) => field.detail).length;
        if (countD > 0 && countD === fields.length && prevState.detail !== true) {
            this.setState({detail: true});
        } else if (countD === 0 && prevState.detail !== false) {
            this.setState({detail: false});
        }
    }

    addChoice() {
        const choices = get(this.props.form.values, this.props.name);
        this.props.push({id: generateNextChoiceId(choices), value: '', shuffle: false, detail: false});
    }

    toggleShuffle(e) {
        const {replace, form, name} = this.props;
        const value = e.target.checked;
        const fields = get(form.values, name);
        this.setState({shuffled: value});

        if (value) {
            fields.forEach((field, index) => {
                replace(index, Object.assign({}, field, {shuffle: true}));
            });
        } else {
            fields.forEach((field, index) => {
                replace(index, Object.assign({}, field, {shuffle: false}));
            });
        }
    }

    toggleDetail(e) {
        const {replace, form, name} = this.props;
        const value = e.target.checked;
        const fields = get(form.values, name);
        this.setState({detail: value});

        if (value) {
            fields.forEach((field, index) => {
                replace(index, Object.assign({}, field, {detail: true}));
            });
        } else {
            fields.forEach((field, index) => {
                replace(index, Object.assign({}, field, {detail: false}));
            });
        }
    }

    render() {
        const {remove, move, form, name} = this.props;

        return (
            <table className="table table-sm table-borderless">
                <colgroup>
                    <col style={{width: 120}} />
                    <col />
                    <col style={{width: 120}} />
                    <col style={{width: 100}} />
                    <col style={{width: 50}} />
                    <col style={{width: 50}} />
                </colgroup>
                <thead>
                    <tr>
                        <th className="pl-0"><FormattedMessage {...messages.surveys.form.label.choiceId} /></th>
                        <th><FormattedMessage {...messages.surveys.form.label.choiceLabel} /></th>
                        <th>
                            <div className="custom-control custom-checkbox">
                                <input className="custom-control-input" type="checkbox"
                                    checked={this.state.detail} onChange={this.toggleDetail} id={`${name}.detail`} />
                                <label className="custom-control-label" htmlFor={`${name}.detail`}>
                                    <FormattedMessage {...messages.surveys.form.label.detail} />
                                    {' '}
                                    <TooltipIcon message={messages.surveys.form.tooltip.detail} />
                                </label>
                            </div>
                        </th>
                        <th colSpan="3">
                            <div className="custom-control custom-checkbox">
                                <input className="custom-control-input" type="checkbox"
                                    checked={this.state.shuffled} onChange={this.toggleShuffle} id={`${name}.shuffled`} />
                                <label className="custom-control-label" htmlFor={`${name}.shuffled`}>
                                    <FormattedMessage {...messages.surveys.form.label.shuffled} />
                                    {' '}
                                    <TooltipIcon message={messages.surveys.form.tooltip.shuffled} />
                                </label>
                            </div>
                        </th>
                    </tr>
                </thead>
                <DragDropTableBody move={move}>
                    {get(form.values, name) && get(form.values, name).map((item, index, arr) => (
                        <DraggableRow item={item} index={index} key={index}>
                            <DraggableCell className="pl-0">
                                <FastField id={`${name}.${index}.id`} name={`${name}.${index}.id`} type="text"
                                    className={classNames('form-control',
                                        {error: get(form.errors, `${name}.${index}.id`) &&
                                        get(form.touched, `${name}.${index}.id`)})}
                                />
                                <ErrorMessage name={`${name}.${index}.id`}>
                                    {(message) => <Error reason={message.key} reasonParams={message.params} />}
                                </ErrorMessage>
                            </DraggableCell>
                            <DraggableCell>
                                <FastField id={`${name}.${index}.value`} name={`${name}.${index}.value`} type="text"
                                    className={classNames('form-control',
                                        {error: get(form.errors, `${name}.${index}.value`) &&
                                        get(form.touched, `${name}.${index}.value`)})}
                                />
                                <ErrorMessage name={`${name}.${index}.value`}>
                                    {(message) => <Error reason={message.key} reasonParams={message.params} />}
                                </ErrorMessage>
                            </DraggableCell>
                            <DraggableCell>
                                <FastField name={`${name}.${index}.detail`}>
                                    {({field}) => (
                                        <div className="custom-control custom-checkbox">
                                            <input type="checkbox" name={field.name} id={`${name}.${index}.detail`}
                                                className="custom-control-input"
                                                checked={field.value} onChange={field.onChange} />
                                            <label className="custom-control-label" htmlFor={`${name}.${index}.detail`}>&nbsp;</label>
                                        </div>
                                    )}
                                </FastField>
                            </DraggableCell>
                            <DraggableCell>
                                <FastField name={`${name}.${index}.shuffle`}>
                                    {({field}) => (
                                        <div className="custom-control custom-checkbox">
                                            <input type="checkbox" name={field.name} id={`${name}.${index}.shuffle`}
                                                className="custom-control-input"
                                                checked={field.value} onChange={field.onChange} />
                                            <label className="custom-control-label" htmlFor={`${name}.${index}.shuffle`}>&nbsp;</label>
                                        </div>
                                    )}
                                </FastField>
                            </DraggableCell >
                            <DraggableCell className="border-right">
                                <div className="d-flex justify-content-center">
                                    <div className="flex-column">
                                        <div className="">{index > 0 && <UpButton move={move} index={index} />}</div>
                                        <div className="">{index + 1 < arr.length && <DownButton move={move} index={index} />}</div>
                                    </div>
                                </div>
                            </DraggableCell>
                            <DraggableCell>
                                <div className="d-flex justify-content-center">
                                    <div className="flex-column">
                                        <MinusButton remove={remove} index={index} />
                                    </div>
                                </div>
                            </DraggableCell>
                        </DraggableRow>
                    ))}
                </DragDropTableBody>
                <tfoot>
                    <tr>
                        <td colSpan="4" className="pl-0">
                            <PlusButton onClick={this.addChoice}>
                                <FormattedMessage {...messages.surveys.button.add_choice} />
                            </PlusButton>
                        </td>
                    </tr>
                </tfoot>
            </table>
        );
    }
}

export default ShuffledDetailChoiceType;
